import { lazy, Suspense } from 'react';
import "assets/styles/index.scss";
import { ConfigProvider } from "antd";
import faIR from "antd/lib/locale/fa_IR";
import routes from 'config/routes';
import { Navigate, Route, Routes } from 'react-router';
import ErrorBoundry from './shared/ErrorBoundry';
import Report from './panel/report';
import { useRecoilValue } from 'recoil';
import AtomTheme from 'recoil/atoms/AtomTheme';
import colors from "config/colors";
import PaymentLink from './panel/paymentLink';
const Dashboard = lazy(() => import('./panel/dashboard'));
const ReportPayment = lazy(() => import('./panel/paymentReport'));
const ReportTransaction = lazy(() => import('./panel/transactionReport'));
const Tracker = lazy(() => import('./panel/tracker'));
const Profile = lazy(() => import('./panel/profile'));
const RecoverPassword = lazy(() => import('./auth/RecoverPassword'));
const Signup = lazy(() => import('./auth/Signup'));
const Document = lazy(() => import('./panel/document'));
const BankAccount = lazy(() => import('./panel/bankAccount'));
const Splash = lazy(() => import("./Splash"));
const Auth = lazy(() => import("./auth"));
const Login = lazy(() => import("./auth/Login"));
const Panel = lazy(() => import("./panel"));
const Token = lazy(() => import("./panel/token"));
const PoDashboard = lazy(() => import('./panel/poDashboard'));
const PoReport = lazy(() => import('./panel/poReport'));
const PoReportPayment = lazy(() => import('./panel/poPaymentReport'));
const PoReportTransaction = lazy(() => import('./panel/poTransactionReport'));
const ApplicationReport = lazy(() => import('./panel/applicationReport'));
const PoApplicationReport = lazy(() => import('./panel/poApplicationReport'));
const SellementReport = lazy(() => import('./panel/settlementReport'));

function App() {
  const theme = useRecoilValue(AtomTheme);
  return (
    <ConfigProvider theme={{
      token: {
        //...theme,
        colorIcon: colors[theme].icon,
        colorLink: colors[theme].text,
        fontFamily: "Vazir"
      },
      components: {
        Menu: {
          colorItemBgSelected: colors[theme].hover
        }
      }
    }}
      direction="rtl" locale={faIR}>
      <ErrorBoundry fallback={() => window.location.reload}>
        <Suspense fallback={<Splash doNothing={true} />}>
          <Routes>
            <Route index element={<Navigate to={routes.panel} replace />} />
            <Route path={routes.panel} element={<Panel />}>
              <Route index element={<Dashboard />} />
              <Route path={routes.dashboard} element={<Dashboard />} />
              <Route path={routes.report} element={<Report />} />
              <Route path={routes.applicationReport} element={<ApplicationReport />} />
              {/* <Route path={routes.changePassword} element={<UpdatePassword />} /> */}
              <Route path={routes.profile} element={<Profile />} />
              <Route path={routes.token} element={<Token />} />
              <Route path={routes.bankAccount} element={<BankAccount />} />
              <Route path={routes.document} element={<Document />} />
              <Route path={routes.paymetsReport} element={<ReportPayment />} />
              <Route path={routes.poDashboard} element={<PoDashboard />} />
              <Route path={routes.poApplicationReport} element={<PoApplicationReport />} />
              <Route path={routes.poReport} element={<PoReport />} />
              <Route path={routes.poPaymetsReport} element={<PoReportPayment />} />
              <Route path={routes.poTransactionsReport} element={<PoReportTransaction />} />
              <Route path={routes.transactionsReport} element={<ReportTransaction />} />
              <Route path={routes.tracker} element={<Tracker />} />
              <Route path={routes.settlementReport} element={<SellementReport />} />
              <Route path={routes.paymentLink} element={<PaymentLink />} />
            </Route>
            <Route path={routes.auth} element={<Auth />}>
              <Route index element={<Login />} />
              <Route path={routes.login} element={<Login />} />
              <Route path={routes.signup} element={<Signup />} />
              <Route path={routes.recoverPassword} element={<RecoverPassword />} />
            </Route>
          </Routes>
        </Suspense>
      </ErrorBoundry>
    </ConfigProvider>
  );
}

export default App;
